var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33205 1.43457H2.17318C1.78226 1.43457 1.40735 1.58986 1.13093 1.86628C0.854511 2.14271 0.699219 2.51761 0.699219 2.90853V13.2263C0.699219 13.6172 0.854511 13.9921 1.13093 14.2685C1.40735 14.5449 1.78226 14.7002 2.17318 14.7002H12.4909C12.8818 14.7002 13.2567 14.5449 13.5332 14.2685C13.8096 13.9921 13.9649 13.6172 13.9649 13.2263V8.0674",
    stroke: "#08478C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0319 1.1581C12.3251 0.864907 12.7228 0.700195 13.1374 0.700195C13.552 0.700195 13.9497 0.864907 14.2429 1.1581C14.5361 1.45129 14.7008 1.84894 14.7008 2.26357C14.7008 2.6782 14.5361 3.07585 14.2429 3.36904L7.60047 10.0122C7.42548 10.187 7.20929 10.315 6.97183 10.3844L4.85448 11.0034C4.79106 11.0219 4.72384 11.023 4.65985 11.0066C4.59586 10.9902 4.53745 10.957 4.49074 10.9102C4.44403 10.8635 4.41074 10.8051 4.39434 10.7411C4.37795 10.6771 4.37906 10.6099 4.39755 10.5465L5.01662 8.42915C5.08628 8.19188 5.21452 7.97595 5.38953 7.80125L12.0319 1.1581Z",
    stroke: "#08478C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCheckIcon);
export default __webpack_public_path__ + "static/media/edit-check-icon.4ac77ff28fdabbfae49aae62deecf006.svg";
export { ForwardRef as ReactComponent };